import type { Auth0ProviderOptions } from '@auth0/auth0-react';
import { Auth0Provider } from '@auth0/auth0-react';
import { getAuth0Audience } from 'legacy/data/apiHelpers';
import React, { useCallback } from 'react';

import { router } from '@/scenes/router';

type Auth0ProviderWithNavigateProps = {
  children: React.ReactNode;
};

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const orgId = import.meta.env.VITE_AUTH0_ORG_ID;

export const Auth0ProviderWithNavigate = ({
  children,
}: Auth0ProviderWithNavigateProps) => {
  const onRedirectCallback = useCallback(
    ((appState) => {
      void router.navigate(appState?.returnTo || window.location.pathname);
    }) as NonNullable<Auth0ProviderOptions['onRedirectCallback']>,
    [router]
  );

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: getAuth0Audience(),
        organization: orgId,
      }}
      useRefreshTokens
      useRefreshTokensFallback
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};
